/* Behuli Size Guide & Fit Finder - v2.2 (11 Sep 2026)
 * - Modal is moved to <body> on open so no animated/transformed section can trap position:fixed
 *   (root cause of the mobile freeze / opens-at-bottom bug).
 * - focus() uses preventScroll so opening never jumps the page.
 * - Delegated events: survives Dawn variant re-renders and theme-editor reloads.
 * - AU size -> Kurti size mapping and inch values taken from /pages/size-guide.
 * - in / cm toggle (remembered), AU size input, 'Select this size' button.
 * - v2.2: trigger now sits below the size fieldset; variant lookup scoped to the trigger's <variant-selects>.
 */
(function () {
  'use strict';
  if (window.__behuliSizeGuideV2) return;
  window.__behuliSizeGuideV2 = true;

  var MODAL_ID = 'behuli-size-guide-modal';
  var LOCK_CLASS = 'behuli-sg-open';
  var UNIT_KEY = 'behuli:sg-unit';
  var activeModal = null;
  var lastTrigger = null;
  var touchStartY = null;
  var unit = (function () { try { return localStorage.getItem(UNIT_KEY) === 'cm' ? 'cm' : 'in'; } catch (_) { return 'in'; } })();

  var SIZES = [
    { label: 'XS (34)', au: 'AU 6', maxCm: 86, maxIn: 34 },
    { label: 'S (36)', au: 'AU 8', maxCm: 91, maxIn: 36 },
    { label: 'M (38)', au: 'AU 10', maxCm: 97, maxIn: 38 },
    { label: 'L (40)', au: 'AU 12', maxCm: 102, maxIn: 40 },
    { label: 'XL (42)', au: 'AU 14', maxCm: 107, maxIn: 42 },
    { label: 'XXL (44)', au: 'AU 16', maxCm: 112, maxIn: 44 },
    { label: '3XL (46)', au: 'AU 18–20', maxCm: 117, maxIn: 46 },
    { label: '4XL (48)', au: '', maxCm: 122, maxIn: 48 },
    { label: '5XL (50)', au: '', maxCm: 127, maxIn: 50 },
    { label: '6XL (52)', au: '', maxCm: 132, maxIn: 52 }
  ];
  var MIN = { cm: 81, in: 32 };
  var AU_TO_INDEX = { 6: 0, 8: 1, 10: 2, 12: 3, 14: 4, 16: 5, 18: 6, 20: 6 };
  var LETTER_RANKS = { XXS: 32, XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44, '2XL': 44, XXXL: 46, '3XL': 46, XXXXL: 48, '4XL': 48, XXXXXL: 50, '5XL': 50, XXXXXXL: 52, '6XL': 52 };

  function sizeRank(raw) {
    var v = String(raw || '').trim().toUpperCase();
    var m = v.match(/(?:\(|\b)(\d{2,3})(?:\)|\b)/);
    if (m) return Number(m[1]);
    return LETTER_RANKS[v.replace(/\s+/g, '')] || 0;
  }

  function focusNoScroll(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); }
  }

  function toIn(cm) { return Math.round((cm / 2.54) * 2) / 2; }

  function resolveModal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('#' + MODAL_ID));
    if (!nodes.length) return null;
    var keep = null;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].parentNode === document.body) { keep = nodes[i]; break; }
    }
    if (!keep) { keep = nodes[0]; document.body.appendChild(keep); }
    nodes.forEach(function (n) { if (n !== keep && n.parentNode) n.parentNode.removeChild(n); });
    return keep;
  }

  function applyUnit(m) {
    if (!m) return;
    m.querySelectorAll('[data-cm]').forEach(function (td) {
      var raw = td.getAttribute('data-cm');
      td.textContent = unit === 'cm' ? raw : raw.replace(/\d+(?:\.\d+)?/g, function (n) { return String(toIn(Number(n))); });
    });
    m.querySelectorAll('[data-unit]').forEach(function (b) {
      var on = b.getAttribute('data-unit') === unit;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    m.querySelectorAll('[data-unit-label]').forEach(function (el) { el.textContent = unit; });
    var bust = m.querySelector('#behuli-ff-bust');
    if (bust) bust.placeholder = unit === 'cm' ? 'e.g. 92' : 'e.g. 36';
  }

  function setUnit(next) {
    if (next === unit || !activeModal) return;
    var bust = activeModal.querySelector('#behuli-ff-bust');
    var v = parseFloat(bust && bust.value);
    if (bust && !isNaN(v)) bust.value = next === 'in' ? String(toIn(v)) : String(Math.round(v * 2.54));
    unit = next;
    try { localStorage.setItem(UNIT_KEY, unit); } catch (_) {}
    applyUnit(activeModal);
    var result = activeModal.querySelector('#behuli-ff-result');
    if (result && !result.hidden) findSize();
  }

  function open(trigger) {
    var modal = resolveModal();
    if (!modal) return;
    lastTrigger = trigger;
    activeModal = modal;
    applyUnit(modal);
    modal.removeAttribute('hidden');
    document.documentElement.classList.add(LOCK_CLASS);
    var body = modal.querySelector('.behuli-sg__body');
    if (body) body.scrollTop = 0;
    setTimeout(function () { focusNoScroll(modal.querySelector('.behuli-sg__close')); }, 30);
  }

  function close() {
    if (!activeModal) return;
    activeModal.setAttribute('hidden', '');
    document.documentElement.classList.remove(LOCK_CLASS);
    activeModal = null;
    if (lastTrigger && lastTrigger.isConnected) focusNoScroll(lastTrigger);
  }

  function switchTab(name) {
    var m = activeModal;
    if (!m) return;
    m.querySelectorAll('.behuli-sg__tab').forEach(function (t) {
      var on = t.getAttribute('data-tab') === name;
      t.classList.toggle('behuli-sg__tab--active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    m.querySelectorAll('.behuli-sg__tab-content').forEach(function (c) {
      c.classList.toggle('behuli-sg__tab-content--hidden', c.id !== 'behuli-tab-' + name);
    });
    var body = m.querySelector('.behuli-sg__body');
    if (body) body.scrollTop = 0;
  }

  function pickByBust(v, u) {
    var key = u === 'cm' ? 'maxCm' : 'maxIn';
    var last = SIZES.length - 1;
    if (v > SIZES[last][key]) return { index: -1 };
    for (var i = 0; i <= last; i++) {
      if (v < SIZES[i][key] || i === last) {
        return { index: i, boundary: i > 0 && v === SIZES[i - 1][key], below: v < MIN[u] };
      }
    }
    return { index: -1 };
  }

  function isSilkProduct() {
    var t = document.querySelector('.product__title h1, .product__title, main h1');
    return !!t && /silk/i.test(t.textContent || '');
  }

  function sizeContainers() {
    var scope = null;
    if (lastTrigger && lastTrigger.isConnected) {
      scope = lastTrigger.closest('[data-behuli-size-option]') || lastTrigger.closest('variant-selects');
    }
    if (scope && scope.hasAttribute('data-behuli-size-option')) return [scope];
    var root = scope || document;
    return Array.prototype.slice.call(root.querySelectorAll('[data-behuli-size-option]'));
  }

  function findVariantOption(rank) {
    if (!rank) return null;
    var containers = sizeContainers();
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      var select = c.querySelector('select');
      if (select) {
        for (var j = 0; j < select.options.length; j++) {
          var o = select.options[j];
          if (sizeRank(o.value) === rank) return { select: select, value: o.value, unavailable: /unavailable|sold/i.test(o.textContent) };
        }
        continue;
      }
      var radios = c.querySelectorAll('input[type="radio"]');
      for (var k = 0; k < radios.length; k++) {
        if (sizeRank(radios[k].value) === rank) return { radio: radios[k], unavailable: radios[k].classList.contains('disabled') };
      }
    }
    return null;
  }

  function selectVariant(option) {
    if (option.radio && option.radio.isConnected) {
      if (!option.radio.checked) option.radio.click();
    } else if (option.select && option.select.isConnected) {
      option.select.value = option.value;
      option.select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    close();
  }

  function findSize() {
    var m = activeModal;
    if (!m) return;
    var q = function (s) { return m.querySelector(s); };
    var auEl = q('#behuli-ff-au'), bustEl = q('#behuli-ff-bust'), heightEl = q('#behuli-ff-height');
    var errorEl = q('#behuli-ff-error'), resultEl = q('#behuli-ff-result');
    var badgeEl = q('#behuli-ff-badge'), textEl = q('#behuli-ff-text'), selectEl = q('#behuli-ff-select');
    var au = parseInt(auEl && auEl.value, 10);
    var bust = parseFloat(bustEl && bustEl.value);
    var height = parseFloat(heightEl && heightEl.value);
    var hasBust = !isNaN(bust) && bust > 0;
    var lo = unit === 'cm' ? 60 : 24, hi = unit === 'cm' ? 170 : 67;

    function showError(msg, focusEl) {
      errorEl.textContent = msg;
      errorEl.hidden = false;
      resultEl.hidden = true;
      focusNoScroll(focusEl);
    }

    if (hasBust && (bust < lo || bust > hi)) { showError('That bust measurement looks off — please check it is in ' + (unit === 'cm' ? 'centimetres' : 'inches') + '.', bustEl); return; }
    if (!hasBust && !au) { showError('Choose your AU size or enter your bust measurement.', auEl); return; }
    errorEl.hidden = true;
    if (selectEl) { selectEl.hidden = true; selectEl._behuliOption = null; }

    var notes = [];
    var index = null;
    var boundary = false;
    var auIndex = au ? (Object.prototype.hasOwnProperty.call(AU_TO_INDEX, au) ? AU_TO_INDEX[au] : -1) : null;

    if (hasBust) {
      var pick = pickByBust(bust, unit);
      if (pick.index === -1) {
        badgeEl.textContent = 'Contact us';
        notes.push('Your bust measurement is above our 6XL (52) range. Message us on WhatsApp and we will recommend the best fit.');
      } else {
        index = pick.index;
        boundary = pick.boundary;
        notes.push('Bust ' + bust + ' ' + unit + ' fits ' + SIZES[index].label + (SIZES[index].au ? ' (≈ ' + SIZES[index].au + ')' : '') + '.');
        if (pick.boundary) notes.push('You are right on the line between two sizes, so we have sized you up.');
        if (pick.below) notes.push('This is below our XS range, so XS may feel roomy — message us for advice.');
        if (auIndex !== null && auIndex !== -1 && auIndex !== index) {
          notes.push('Your AU ' + au + ' usually maps to ' + SIZES[auIndex].label + ', but your measurement points to ' + SIZES[index].label + '. Go with the measurement — AU sizing varies between brands.');
        }
      }
    } else if (auIndex === -1) {
      badgeEl.textContent = 'Measure';
      notes.push('AU 22 and above sits outside our AU chart. Enter your bust measurement — we stock up to 6XL (52).');
      focusNoScroll(bustEl);
    } else {
      index = auIndex;
      notes.push('AU ' + au + ' usually fits ' + SIZES[index].label + '. For the most accurate fit, add your bust measurement.');
    }

    if (index !== null) {
      badgeEl.textContent = SIZES[index].label;
      if (isSilkProduct() && !boundary && index < SIZES.length - 1) {
        notes.push('This piece is silk, which has less stretch — our guide suggests one size up (' + SIZES[index + 1].label + ') for the same comfort.');
      }
      var option = findVariantOption(sizeRank(SIZES[index].label));
      if (option && selectEl) {
        selectEl._behuliOption = option;
        selectEl.textContent = option.unavailable ? 'Select ' + SIZES[index].label + ' (sold out)' : 'Select ' + SIZES[index].label;
        selectEl.hidden = false;
      } else if (sizeContainers().length) {
        notes.push('This style is not currently offered in that size.');
      }
    }

    if (height && height < 158) notes.push('Under 158 cm? Longer styles may need hemming.');
    if (height && height > 178) notes.push('Over 178 cm? Check the garment length on this product before ordering.');
    textEl.textContent = notes.join(' ');
    resultEl.hidden = false;
  }

  function trapTab(e) {
    var items = Array.prototype.filter.call(
      activeModal.querySelectorAll('button, input, select, a[href], [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && !el.hidden && el.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var trigger = e.target.closest('.behuli-sg__trigger');
    if (trigger) { e.preventDefault(); open(trigger); return; }
    if (!activeModal || !activeModal.contains(e.target)) return;
    if (e.target.closest('.behuli-sg__close, .behuli-sg__backdrop')) { close(); return; }
    var tab = e.target.closest('.behuli-sg__tab');
    if (tab) { switchTab(tab.getAttribute('data-tab')); return; }
    var unitBtn = e.target.closest('[data-unit]');
    if (unitBtn) { setUnit(unitBtn.getAttribute('data-unit')); return; }
    var go = e.target.closest('[data-tab-go]');
    if (go) { switchTab(go.getAttribute('data-tab-go')); focusNoScroll(activeModal.querySelector('#behuli-ff-au')); return; }
    if (e.target.closest('#behuli-ff-find')) { findSize(); return; }
    var sel = e.target.closest('#behuli-ff-select');
    if (sel && sel._behuliOption) selectVariant(sel._behuliOption);
  });

  document.addEventListener('keydown', function (e) {
    if (!activeModal) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') { trapTab(e); return; }
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.behuli-ff__field input')) { e.preventDefault(); findSize(); }
  });

  document.addEventListener('touchstart', function (e) {
    if (!activeModal || !e.target.closest) return;
    if (e.target.closest('.behuli-sg__head') && !e.target.closest('button')) touchStartY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (touchStartY === null) return;
    var dy = e.changedTouches[0].clientY - touchStartY;
    touchStartY = null;
    if (dy > 70) close();
  }, { passive: true });
})();
